module.exports = __webpack_public_path__ + "img/award.fc084266.svg";